module.exports = __webpack_public_path__ + "./images/userfront.748c5b.jpg";